module.exports = __webpack_public_path__ + "img/courier-estesexpress.b96ada38.svg";